import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { APP_ROUTES } from '@/routes/routes.type';
import { AuthStore } from '@/store/auth.store';
import { PublicDiagnosticLaunchService } from './public-diagnostic-launch.service';

/**
 * One-shot guest entry to the public diagnostic page.
 * Returns UrlTree redirects; does not call `router.navigate()` as a side effect.
 */
export const publicDiagnosticEntryGuard: CanActivateFn = () => {
  const authStore = inject(AuthStore);
  const launchService = inject(PublicDiagnosticLaunchService);
  const router = inject(Router);

  if (authStore.isAuthenticated()) {
    return router.createUrlTree(['/', APP_ROUTES.DASHBOARD]);
  }

  if (launchService.consume()) {
    return true;
  }

  return router.createUrlTree(['/']);
};
